import { render, staticRenderFns } from "./Rfqs.vue?vue&type=template&id=71f1be80"
import script from "./Rfqs.vue?vue&type=script&lang=js"
export * from "./Rfqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports